<div class="u-wrapper" data-testid="previsit-ticket-created" [attr.data-ticket-id]="vm.preVisitTicketId"
	[ngStyle]="!vm.isInitialized && {'min-height': '200px'}">
	<div class="c-card u-osb-md o-grid__cell--center-h">
		<div class="c-content c-content--lg">
			<div class="o-grid o-grid--center-v">
				<div class="o-grid__cell">
					<img [attr.src]="'https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/icons/icon-email-moving' + vm.iconSuffix + '.svg'" />
					<br/>
					<h1 id="thanksMessageLabel" class="c-text c-text--heading c-text--s6 c-text--lg">
						{{'Common.Thanks' | translate}}
					</h1>
					<br/>
					<div [innerHtml]="vm.informationSection"></div>
					<br/>
					<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed u-no-p">
						<a id="goToPaidServicesButton" href="" class="c-button c-button--s1 c-button--lg c-button--fit@up-to-sm u-osb-md u-osr-md" *ngIf="!vm.isRecordTicketForPerson && !vm.user?.previsitUser">
							{{'PreVisit.Common.Paid_Services' | translate}}
						</a>
						<a id="goToPreVisitServicesButton" [routerLink]="['/pre-visit']" class="c-button c-button--s1 c-button--lg c-button--fit@up-to-sm">
							{{'PreVisit.Common.PreVisit_Services' | translate}}
						</a>
					</div>
				</div>
			</div>
			<div class="u-ost-lg">
				<pre-visit-feedback [preVisitTicketId]="vm.preVisitTicketId"></pre-visit-feedback>
			</div>
		</div>
	</div>
	<div id="stateCheckElementForAutomatedTests"></div>
</div>
